export default `
mutation ResendSPTempPass($email: AWSEmail!){
  resendSPTempPass(email: $email) {
    email
  }
}
`;